import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rota } from '../../../model';
import { Observable } from 'rxjs';
import { API } from '../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class RotaService {

  constructor(
    private http: HttpClient
  ) { }

  post(rota: Rota): Observable<Rota> {
    return this.http.post<Rota>(
      `${API}/api/rotarodoviaria`,
      rota
    );
  }

  put(rota: Rota): Observable<Rota> {
    return this.http.put<Rota>(
      `${API}/api/rotarodoviaria/${rota.Id}`,
      rota
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${API}/api/rotarodoviaria/${id}`
    );
  }
}
